import place from '../../content/places/arenal/place.json'
import hotspotsFile from '../../content/places/arenal/hotspots.json'
import viewpointsFile from '../../content/places/arenal/viewpoints.json'
import stratovolcano from '../../content/places/arenal/facts/arenal-stratovolcano.json'
import lake from '../../content/places/arenal/facts/lake-arenal.json'
import forest from '../../content/places/arenal/facts/cloud-forest-edge.json'
import fortuna from '../../content/places/arenal/facts/la-fortuna.json'
import wind from '../../content/places/arenal/facts/arenal-wind.json'
import springs from '../../content/places/arenal/facts/hot-springs.json'
import dam from '../../content/places/arenal/facts/presa-sangregado.json'
import waterfall from '../../content/places/arenal/facts/la-fortuna-waterfall.json'
import type { Fact, Hotspot, Place, Viewpoint } from '../types'
import { latLonToWorld } from '../world/geo'

const facts: Record<string, Fact> = {
  [stratovolcano.id]: stratovolcano,
  [lake.id]: lake,
  [forest.id]: forest,
  [fortuna.id]: fortuna,
  [wind.id]: wind,
  [springs.id]: springs,
  [dam.id]: dam,
  [waterfall.id]: waterfall,
}

export function loadArenal(): {
  place: Place
  hotspots: Hotspot[]
  facts: Record<string, Fact>
  viewpoints: Viewpoint[]
} {
  const hotspots = (hotspotsFile.hotspots as Hotspot[]).map((hotspot) => {
    if (!hotspot.location) return hotspot
    const { x, z } = latLonToWorld(hotspot.location.lat, hotspot.location.lon)
    return { ...hotspot, position: [x, 0, z] as [number, number, number] }
  })
  return {
    place: place as Place,
    hotspots,
    facts,
    viewpoints: viewpointsFile.viewpoints as Viewpoint[],
  }
}
